import { locale, sortByEarliestDate, getStatementRangeLabel } from '..';

/**
 * Returns a descriptive name for a list of TrqkStatementViewPartials which includes the PRO and the
 * date range of the list of statements for example, "ASCAP 2019 Q4 - 2020 Q1".
 * - If there are no statementViews, the default name such as "Selected Statements" is returned.
 * - If there is only one statementView, only its date range is used, resulting in a value like
 *   "ASCAP 2019 Q4"
 * @param statementViews array of TrqkStatementView objects
 * @param short Default name for selection
 */
export const getStatementListLabel = (
    statementViews: TrqkStatementView[],
    short: string,
    showPro = true,
): string => {
    if (statementViews.length < 1) {
        return short;
    }
    const statementViewsEarliestFirst = [...statementViews]
        .sort((a: TrqkStatementView, b: TrqkStatementView): number =>
            sortByEarliestDate(a?.end_date ?? null, b?.end_date ?? null),
        )
        .filter(
            ({ statement_id }: TrqkStatementView): boolean =>
                statement_id !== null,
        );

    const pro = statementViewsEarliestFirst[0]?.pro ?? locale.enUS.UNKNOWN_PRO;
    const region = statementViewsEarliestFirst[0]?.region ?? null;

    const firstStatementPeriod = {
        end_date: statementViewsEarliestFirst[0].end_date ?? null,
        start_date: statementViewsEarliestFirst[0].start_date ?? null,
    };

    let lastStatementPeriod;

    if (statementViewsEarliestFirst.length > 1) {
        lastStatementPeriod = {
            end_date:
                statementViewsEarliestFirst[
                    statementViewsEarliestFirst.length - 1
                ].end_date ?? null,
            start_date:
                statementViewsEarliestFirst[
                    statementViewsEarliestFirst.length - 1
                ].start_date ?? null,
        };
    }

    return getStatementRangeLabel({
        pro,
        region,
        firstStatementPeriod,
        lastStatementPeriod,
        defaultPeriodLabel: locale.enUS.UNKNOWN_PERIOD,
        showPro,
    });
};
